export default "__VITE_PUBLIC_ASSET__1b867f43__"